import { getSearchParam, keysVsVal } from "@/utils";
import { isTrTabLanguageHost, resolveTrTabLanguageCode } from "@/utils/trTabLanguageResolver";
const lan_en = keysVsVal(["en-us", "en-in"], "en");
const lan_id = keysVsVal(["id-id"], "id");
const lan_ru_ru = keysVsVal(["ru-ru"], "ru-ru");
const lan_hi = keysVsVal(["hi-in"], "hi");
const lan_es = keysVsVal(["es-es"], "es");
const lan_es_mx = keysVsVal(["es-co", "es-mx"], "es-mx");
const lan_pt = keysVsVal(["pt-br"], "pt");
const lan_tr_tr = keysVsVal(["tr-tr"], "tr-tr");
const lan_en_gb = keysVsVal(["en-gb"], "en-gb");
const lan_fr_fr = keysVsVal(["fr-fr"], "fr-fr");
const lan_de_de = keysVsVal(["de-de"], "de-de");
const all_con_lan = {
  ...lan_en,
  ...lan_id,
  ...lan_ru_ru,
  ...lan_hi,
  ...lan_es,
  ...lan_es_mx,
  ...lan_pt,
  ...lan_tr_tr,
  ...lan_en_gb,
  ...lan_fr_fr,
  ...lan_de_de,
};

export default function useLanguage(_d = "en") {
  const { hostName, domain } = useHostName();
  const { subdomain } = useSubdomain();
  const lanParam = getSearchParam("lan");
  const conParam = getSearchParam("con");
  const channelParam = getSearchParam("channel");

  let lan: any = (lanParam || "").toLowerCase();
  if (isTrTabLanguageHost({ hostName, domain, subdomain, channel: channelParam })) {
    lan = resolveTrTabLanguageCode({
      lan: lanParam,
      con: conParam,
    });
  } else {
    lan = all_con_lan[lan] ?? lan;
  }

  const curLan = lan.replace(/_/g, "-");
  const isRtl =
    ["arabic-mils", "ar", "ur", "he", "iw", "fa-ir"].includes(lan) ||
    ["arabic-mils.comfortweather.com", "urdu-mils.comfortweather.com"].includes(hostName);
  return {
    lan,
    isRtl,
    curLan,
  };
}
